export const CCAVENUE_ACQUIRER = 2002;
export const FLEXIPAY_BY_HDFC_ACQUIRER = 9003;
